/**
 * 10% Off Everything countdown (ported from fanola.hair's vat-free-timer.js).
 *
 * Repaints every [data-sale-deadline] clock once a second. Stateless: each tick
 * re-queries the DOM, so markup re-rendered by section/variant updates is picked
 * up without rebinding. Past the deadline the whole [data-sale-banner] is hidden,
 * so a page left open across the deadline never keeps promising the offer.
 */
(function () {
  'use strict';
  if (window.__saleCountdown) return; // the snippet can include this file more than once

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function tick(now) {
    var clocks = document.querySelectorAll('[data-sale-deadline]');
    for (var i = 0; i < clocks.length; i++) {
      var el = clocks[i];
      // Deadline carries an explicit UTC offset so visitors abroad read it right.
      var deadline = Date.parse(el.getAttribute('data-sale-deadline'));
      if (isNaN(deadline)) continue;

      var left = Math.floor((deadline - now) / 1000);
      if (left <= 0) {
        (el.closest('[data-sale-banner]') || el).hidden = true;
        continue;
      }
      var parts = {
        d: String(Math.floor(left / 86400)),
        h: pad(Math.floor((left % 86400) / 3600)),
        m: pad(Math.floor((left % 3600) / 60)),
        s: pad(left % 60)
      };
      for (var u in parts) {
        var node = el.querySelector('[data-u="' + u + '"]');
        if (node && node.textContent !== parts[u]) node.textContent = parts[u];
      }
    }
  }

  window.__saleCountdown = { tick: tick };
  tick(Date.now());
  setInterval(function () {
    tick(Date.now());
  }, 1000);
})();
